import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import logger from '../lib/helpers/logger';
import Layout from '../components/layout';
import { usePageRendererHooks } from '../components/page-renderer/hooks';
import FooterButton from '../components/button-footer';
import { store } from '../lib/stores/store';
import GenericPage from '../components/page-generic';
import image from '../assets/CannotContinue.svg';

export default function RouteErrorBoundary() {
	const error = useRouteError();
	const { config, getString, handleNavigation } = usePageRendererHooks();
	const cancelButtonText = getString(config?.cancelButtonTextContent) || 'Cancel';

	useEffect(() => {
		logger.logGeneral.error(
			{},
			`Unexpected application error: ${error instanceof Error ? error.message : String(error)}`,
			error instanceof Error ? { stack: error.stack } : undefined
		);
	}, [error]);

	return (
		<Layout
			key={'unavailable'}
			mainContent={
				<GenericPage
					title={'Unable to Continue'}
					imageSrc={image}
					imageAlt='Unable to Continue'
					message={`We apologize for the inconvenience.  Select "${cancelButtonText}" to try again.`}
				/>
			}
			logoProps={{ src: config?.logoSrc, alt: getString(config?.logoAlt) }}
			navProps={{ handleNavigation }}
			footerContent={
				<FooterButton theme='exit' innerText={cancelButtonText} onClick={async () => await store.sessionStore.startEndSessionTasks()} />
			}
		/>
	);
}
